import React from "react";
import "./DashboardLink.scss";
import { useHistory } from "react-router-dom";
import { faro } from "@grafana/faro-react";

const DashboardLink = ({ text, icon, link }) => {
  const history = useHistory();
  const transactionClick = () => {
    history.push(link);
    faro.api.pushEvent(`User clicked to ${link.toString().replace("/", "").replace(/[A-Z]/g, (x) => ` ${x.toLowerCase()}` )}`);
  };

  return (
    <div className="dashboard-link" onClick={transactionClick}>
      <div className="green-circle">
        <img alt={text} src={icon} />
      </div>
      {text}
    </div>
  );
};

export default DashboardLink;
